module.exports = __webpack_public_path__ + "static/img/LOGO.85be07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/Horizon/LOGO.png
// module id = 3PfF
// module chunks = 0